/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  DoneIcon,
  HeaderContainer,
  IconContainer,
  StyledAccordion,
  StyledAccordionSummary
} from "./styled";
import { AccordionFooter } from "../../containers/SalesAssistViews/AccordionFooter";
import { ICONS } from "../Icons";
import { Divider } from "../Divider";

export const CustomAccordian = ({
  accordianHeader,
  withdrawFooter = false,
  children,
  isExpanded = false,
  isFilled = false,
  setIsExpanded = () => {}
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  useEffect(() => {
    setExpanded(isExpanded);
  }, [isExpanded]);

  return (
    <StyledAccordion expanded={expanded}>
      <StyledAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        onClick={() => {
          setIsExpanded(!expanded);
          setExpanded(!expanded);
        }}
      >
        {isFilled ? (
          <HeaderContainer>
            <IconContainer>{isFilled && <DoneIcon name={ICONS.done} />}</IconContainer>
            <div>{accordianHeader}</div>
          </HeaderContainer>
        ) : (
          accordianHeader
        )}
      </StyledAccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
      {withdrawFooter && (
        <>
          <Divider.Dark />
          <AccordionFooter
            expanded
            toggleExpand={() => {
              setIsExpanded(!expanded);
              setExpanded(!expanded);
            }}
          />
        </>
      )}
    </StyledAccordion>
  );
};
CustomAccordian.propTypes = {
  accordianHeader: PropTypes.node.isRequired,
  withdrawFooter: PropTypes.bool,
  children: PropTypes.node,
  isExpanded: PropTypes.bool,
  isFilled: PropTypes.bool,
  setIsExpanded: PropTypes.func
};
